import { SET_SHIFT_TO_VIEW } from '@/store/action-types';

export function setShiftToView(shiftId: number | null) {
  return {
    type: SET_SHIFT_TO_VIEW,
    payload: shiftId,
  };
}
